// To fix issue from AlgoliaSearch Javascript Client : https://github.com/algolia/algoliasearch-client-javascript/issues/691
/* eslint-disable no-restricted-imports */
import '@angular/localize/init';
/** IE10 and IE11 requires the following for NgClass support on SVG elements */
import 'classlist.js';
// Run `npm install --save classlist.js`.

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 */
import 'web-animations-js';
// Run `npm install --save web-animations-js`.
// rtc peer connection patch
import 'zone.js';

(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
(window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
(window as any).__Zone_enable_cross_context_check = true;

// https://github.com/algolia/algoliasearch-client-javascript/issues/691
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
(window as any).process = {
  env: { DEBUG: undefined },
};

// Define unknown CSS properties used in Angular animations
['flex', 'flexDirection', 'willChange'].forEach((prop) => {
  // Test if the property can be configured
  try {
    Object.defineProperty(document.body.style, prop, {
      enumerable: true,
      configurable: true,
    });
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Property '${prop}' cannot be configured.`);
  }
});
// Fix IE11
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (!Element.prototype.matches) {
  // eslint-disable-next-line
  Element.prototype.matches = (Element.prototype as any).msMatchesSelector;
}
